import { ToggleButtonGroup } from '@mui/material';
import { useTypedTranslate } from 'providers/i18n/hooks/useTypedTranslate';

import { StyledToggleButton } from './OrderConversionListPeriodToggle.styled';

type Props = {
  value: string;
  onChange: (event: React.MouseEvent<HTMLElement>, newValue: ConversionPeriod) => void;
};

export const enum ConversionPeriod {
  Hour1 = '1',
  Hour4 = '4',
  Hour8 = '8',
  Hour12 = '12',
}

export const OrderConversionListPeriodToggle: React.FC<Props> = ({ value, onChange }) => {
  const translate = useTypedTranslate();
  return (
    <ToggleButtonGroup
      aria-label="Platform"
      color="primary"
      exclusive
      onChange={onChange}
      value={value}
    >
      <StyledToggleButton sx={{ padding: '8px' }} value={ConversionPeriod.Hour1}>
        {translate('app.orderConversion.hours1')}
      </StyledToggleButton>
      <StyledToggleButton value={ConversionPeriod.Hour4}>
        {translate('app.orderConversion.hours4')}
      </StyledToggleButton>
      <StyledToggleButton value={ConversionPeriod.Hour8}>
        {translate('app.orderConversion.hours8')}
      </StyledToggleButton>
      <StyledToggleButton value={ConversionPeriod.Hour12}>
        {translate('app.orderConversion.hours12')}
      </StyledToggleButton>
    </ToggleButtonGroup>
  );
};
